import { FaPlus } from "react-icons/fa";
import { checkAdmin } from "../../utils/jwtUtils";
import { useElemContext } from "../../Contexts/ElemContext";

export default function AddButton({ pathname }) {
  const { setStudent, setExaminer } = useElemContext();

  if (!checkAdmin()) return null;

  const handlers = {
    "/student": () => setStudent(-1),
    "/examiner": () => setExaminer(-1),
  };

  const onClick = handlers[pathname];
  if (!onClick) return null;

  return (
    <button
      className="bg-white hover:bg-gray-100 border border-black w-14 h-12 flex justify-center"
      onClick={onClick}
      aria-label="ajouter un élément"
    >
      <FaPlus className="h-12" />
    </button>
  );
}
